var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"whole-row",attrs:{"value":_vm.value,"clearable":"","placeholder":"请选择"},on:{"input":_vm.change}},[_c('el-option',{attrs:{"label":"启用","value":1}}),_c('el-option',{attrs:{"label":"停用","value":-1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }